module.exports = __webpack_public_path__ + "img/12-13.b1cd44df.png";